module.exports = __webpack_public_path__ + "static/media/location-white.7771e7da.svg";


//////////////////
// WEBPACK FOOTER
// ./src/images/location-white.svg
// module id = 718
// module chunks = 0